var path = '/opt/atlassian/pipelines/agent/build/src/app/common/app-nav/app-nav-footer.html';
var html = "<footer class=navbar-fixed-bottom> <div class=container> <div class=footer-div> <p class=pull-left>National Veterans Transition Services, Inc &copy; All Rights Reserved</p> </div> </div> </footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/app-nav/app-nav-footer.html
// module id = 898
// module chunks = 0